// import { useQueryClient } from "@tanstack/react-query";
import React, { useEffect } from "react";
// import LoaderLayout from "../../../components/Layout/LoaderLayout";
// import useQueryFetch from "../../../hooks/useQueryFetch";
// import request from "../../../utils/request";
import SettingsFormContainer from "./SettingsFormContainer";
import toast from "react-hot-toast";
import request from "../../../request/request";
import useFetch from "../../../hooks/useFetch";
import LoaderLayout from "../../../components/Loader/LoaderLayout";

const SettingsPage = () => {
    // const queryClient = useQueryClient();

    // const { data, isLoading } = useFetch("settings", () =>
    //     request.getOne("settings", 1)
    // );
    const { result: data, isLoading } = useFetch(() => request.getOne('settings', 1));
    console.log("Settings data", data);
    //   const { data, isLoading } = useQueryFetch("settings", () =>
    //     request.getOne("settings", 1)
    //   );

    useEffect(() => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = `${process.env.REACT_APP_UPLOAD_URL}/${data?.fav_image}`;
    }, [data?.fav_image]); // Add data?.fav_image as depe</div>ndency

    const formDataConverter = (values) => {
        const formData = new FormData();

        Object.keys(values).forEach((data) => {
            formData.append(data, values[data]);
        });
        return formData;
    };

    const submitFormHandler = async (values) => {
        try {
            await request.updateOne("settings", "", formDataConverter(values), 
            // () => {
            //     queryClient.invalidateQueries(["settings"]);
            // }
        );
        } catch (error) {
            console.log(error);
            toast.error(
                error?.response?.data?.data?.error ||
                "Something went wrong! or no folder found"
            );
        }
    };

    return (
        <LoaderLayout isPending={isLoading}>
            <div className="row text-dark">
                <div className="col-xl-12 mx-auto">
                    <div className="card">
                        <div className="card-body">
                            <SettingsFormContainer
                                settingsData={data}
                                submitFormHandler={submitFormHandler}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </LoaderLayout>
    );
};

export default SettingsPage;
